import { getPageStatus, PageLayout } from 'components/PageLayout';
import { useAlert } from 'features/alerts/hooks/useAlert';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import { useAuthState } from 'state/useAuthState';
import { EditAlertForm } from './EditAlertForm';

export const EditAlert = (
  props: RouteComponentProps<{ alertId: string }>,
): JSX.Element => {
  const {
    match: {
      params: { alertId },
    },
  } = props;
  const { t } = useTranslation();
  const {
    permissions: { canReportWildfire },
  } = useAuthState();
  const { isLoading, isError, error, alert } = useAlert({
    id: parseInt(alertId, 10),
  });

  const status = getPageStatus({
    isUnauthorized: !canReportWildfire,
    isLoading,
    isError: isError || !alert,
  });

  return (
    <PageLayout
      data-cname="EditAlert"
      status={status}
      headerBarProps={{ title: t('editAlert.title'), action: 'back' }}
      errorMessage={error ? JSON.stringify(error) : undefined}
    >
      <Helmet>
        <title>{t('editAlert.title')}</title>
      </Helmet>
      {alert && <EditAlertForm alert={alert} />}
    </PageLayout>
  );
};
